/**
 * 点击按钮复制折扣码
 * 适用于整站所有包含 .code-btn 的元素
 *
 * iOS（含 iPhone Chrome，内核为 WebKit）：
 * clipboard.writeText 若异步失败，再走 fallback 已离开「用户手势」窗口，会再次失败。
 * 触摸设备因此优先在同步栈内用 execCommand 完成复制。
 */
(function () {
  const buttonTimers = new Map();

  function isTouchLike() {
    return (
      window.matchMedia("(hover: none), (pointer: coarse)").matches ||
      "ontouchstart" in window ||
      (navigator.maxTouchPoints || 0) > 0
    );
  }

  function copyTextFallback(text) {
    return new Promise(function (resolve, reject) {
      var ok = false;
      var span = document.createElement("span");
      span.textContent = text;
      span.setAttribute("aria-hidden", "true");
      span.style.cssText =
        "position:fixed;top:0;left:0;max-width:100%;opacity:0.01;z-index:2147483647;white-space:pre;-webkit-user-select:text;user-select:text;";
      document.body.appendChild(span);

      var range = document.createRange();
      range.selectNodeContents(span);
      var sel = window.getSelection();
      if (sel) {
        sel.removeAllRanges();
        sel.addRange(range);
      }

      try {
        ok = document.execCommand("copy");
      } catch (err) {
        ok = false;
      }

      if (sel) sel.removeAllRanges();
      document.body.removeChild(span);

      if (ok) {
        resolve();
        return;
      }

      var ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.cssText =
        "position:fixed;top:0;left:0;width:2em;height:2em;padding:0;border:0;outline:0;background:transparent;opacity:0.01;z-index:2147483647;";
      document.body.appendChild(ta);
      ta.focus();
      ta.setSelectionRange(0, text.length);
      try {
        ok = document.execCommand("copy");
      } catch (err2) {
        ok = false;
      }
      document.body.removeChild(ta);

      if (ok) resolve();
      else reject(new Error("copy failed"));
    });
  }

  function copyText(text) {
    if (isTouchLike()) {
      return copyTextFallback(text).catch(function () {
        if (navigator.clipboard && window.isSecureContext) {
          return navigator.clipboard.writeText(text);
        }
        return Promise.reject(new Error("copy failed"));
      });
    }

    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () {
        return copyTextFallback(text);
      });
    }
    return copyTextFallback(text);
  }

  function markCopied(btn) {
    if (buttonTimers.has(btn)) {
      clearTimeout(buttonTimers.get(btn));
    } else {
      btn.dataset.originalText = btn.textContent;
    }

    btn.textContent = "Copied!";
    btn.style.color = "#FFA543";

    var timer = setTimeout(function () {
      btn.textContent = btn.dataset.originalText || "Copy";
      btn.style.color = "";
      buttonTimers.delete(btn);
    }, 2000);

    buttonTimers.set(btn, timer);
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".code-btn");
    if (!btn) return;

    var codeToCopy = btn.getAttribute("data-codetext");
    if (!codeToCopy) return;

    // 勿 preventDefault：iOS 上可能打断用户手势链
    copyText(codeToCopy)
      .then(function () {
        markCopied(btn);
      })
      .catch(function () {});
  });
})();

/**
 * Collection sidebar mega menu: hover / click tab switching
 */
(function () {
  function activateMegaMenuPanel(menuRoot, navItem) {
    const panelId = navItem.getAttribute("data-collection-panel");
    if (!panelId) return;

    const navItems = menuRoot.querySelectorAll(".mega-menu-collection__nav-item");
    const panels = menuRoot.querySelectorAll(".mega-menu-collection__panel");

    navItems.forEach((nav) => {
      const isActive = nav === navItem;
      nav.classList.toggle("is-active", isActive);
      nav.setAttribute("aria-expanded", isActive ? "true" : "false");
    });

    panels.forEach((panel) => {
      const isActive = panel.id === panelId;
      panel.classList.toggle("is-active", isActive);
      panel.toggleAttribute("hidden", !isActive);
    });
  }

  document.addEventListener("mouseover", function (event) {
    const navItem = event.target.closest(".mega-menu-collection__nav-item");
    if (!navItem) return;

    const menuRoot = navItem.closest(".mega-menu--collection");
    if (!menuRoot) return;

    if (navItem.classList.contains("is-active")) return;

    activateMegaMenuPanel(menuRoot, navItem);
  });

  document.addEventListener(
    "click",
    function (event) {
      const navItem = event.target.closest(".mega-menu-collection__nav-item");
      if (!navItem) return;

      const menuRoot = navItem.closest(".mega-menu--collection");
      if (!menuRoot) return;

      event.preventDefault();
      event.stopPropagation();
      activateMegaMenuPanel(menuRoot, navItem);
    },
    true
  );
})();

/**
 * Mobile accordion navigation drawer
 */
(function () {
  function getAccordionTrigger(item) {
    if (!item) return null;
    return item.querySelector(":scope > .mobile-nav-accordion__trigger [data-accordion-trigger]");
  }

  function collapseItem(trigger, item, panel) {
    if (!trigger || !item) return;

    trigger.setAttribute("aria-expanded", "false");
    item.classList.remove("is-expanded");

    if (!panel) return;

    panel.hidden = true;
    panel.querySelectorAll("[data-accordion-item].is-expanded").forEach((nestedItem) => {
      const nestedTrigger = getAccordionTrigger(nestedItem);
      const nestedPanel = nestedItem.querySelector(":scope > .mobile-nav-accordion__panel");
      collapseItem(nestedTrigger, nestedItem, nestedPanel);
    });
  }

  function updateLevelDimming(container, level, activeTrigger) {
    if (!container) return;

    container.querySelectorAll(`[data-accordion-item][data-accordion-level="${level}"]`).forEach((item) => {
      const trigger = getAccordionTrigger(item);
      if (!activeTrigger) {
        item.classList.remove("is-dimmed");
        return;
      }

      item.classList.toggle("is-dimmed", trigger !== activeTrigger);
    });
  }

  function resetMobileNav(drawer) {
    const nav = drawer.querySelector("[data-mobile-nav-accordion]");
    if (!nav) return;

    nav.querySelectorAll("[data-accordion-trigger]").forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "false");
    });
    nav.querySelectorAll("[data-accordion-item]").forEach((item) => {
      item.classList.remove("is-expanded", "is-dimmed");
    });
    nav.querySelectorAll(".mobile-nav-accordion__panel").forEach((panel) => {
      panel.hidden = true;
    });
  }

  function bindMobileNavDrawers() {
    document.querySelectorAll(".mobile-nav-drawer[data-mobile-accordion-nav]").forEach((drawer) => {
      if (drawer.dataset.mobileNavBound === "true") return;
      drawer.dataset.mobileNavBound = "true";
      drawer.addEventListener("dialog:after-hide", () => resetMobileNav(drawer));
    });
  }

  document.addEventListener(
    "click",
    function (event) {
      const trigger = event.target.closest("[data-accordion-trigger]");
      if (!trigger) return;

      const nav = trigger.closest("[data-mobile-nav-accordion]");
      if (!nav) return;

      event.preventDefault();
      event.stopPropagation();

      const level = trigger.getAttribute("data-accordion-level");
      const item = trigger.closest("[data-accordion-item]");
      const panelId = trigger.getAttribute("aria-controls");
      const panel = panelId ? document.getElementById(panelId) : null;
      const isOpen = trigger.getAttribute("aria-expanded") === "true";

      if (level === "1") {
        nav.querySelectorAll('[data-accordion-trigger][data-accordion-level="1"]').forEach((otherTrigger) => {
          if (otherTrigger === trigger) return;
          const otherItem = otherTrigger.closest("[data-accordion-item]");
          const otherPanelId = otherTrigger.getAttribute("aria-controls");
          const otherPanel = otherPanelId ? document.getElementById(otherPanelId) : null;
          collapseItem(otherTrigger, otherItem, otherPanel);
        });
      }

      if (level === "2") {
        const parentPanel = item ? item.closest(".mobile-nav-accordion__panel") : null;
        if (parentPanel) {
          parentPanel.querySelectorAll('[data-accordion-trigger][data-accordion-level="2"]').forEach((otherTrigger) => {
            if (otherTrigger === trigger) return;
            const otherItem = otherTrigger.closest("[data-accordion-item]");
            const otherPanelId = otherTrigger.getAttribute("aria-controls");
            const otherPanel = otherPanelId ? document.getElementById(otherPanelId) : null;
            collapseItem(otherTrigger, otherItem, otherPanel);
          });
        }
      }

      if (isOpen) {
        collapseItem(trigger, item, panel);
      } else {
        trigger.setAttribute("aria-expanded", "true");
        item.classList.add("is-expanded");
        if (panel) panel.hidden = false;
      }

      const expandedL1 = nav.querySelector('[data-accordion-trigger][data-accordion-level="1"][aria-expanded="true"]');
      updateLevelDimming(nav, "1", expandedL1 || null);

      if (level === "1") {
        const activeL1Panel = expandedL1 ? document.getElementById(expandedL1.getAttribute("aria-controls")) : null;
        updateLevelDimming(activeL1Panel, "2", null);
      }

      if (level === "2") {
        const parentPanel = item ? item.closest(".mobile-nav-accordion__panel") : null;
        const expandedL2 = nav.querySelector('[data-accordion-trigger][data-accordion-level="2"][aria-expanded="true"]');
        updateLevelDimming(parentPanel, "2", expandedL2 || null);
      }
    },
    true
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindMobileNavDrawers);
  } else {
    bindMobileNavDrawers();
  }
})();

/**
 * 通用滚动显现动效（样式见 assets/general.css「通用滚动显现动效」）
 * - [data-scroll-reveal] 进入视口中下部时加 .is-revealed，离开后移除（可重复触发）
 * - data-scroll-reveal="once" 仅触发一次
 * - 容器内 .scroll-reveal-item 自动写入 --reveal-order 实现错开入场
 * - prefers-reduced-motion / 不支持 IntersectionObserver 时直接显示
 * 动态插入的内容可调用 window.ScrollReveal.init(root)
 */
(function () {
  var SELECTOR = "[data-scroll-reveal]";
  var ITEM_SELECTOR = ".scroll-reveal-item";
  var mobileMq = window.matchMedia("(max-width: 768px)");
  var reducedMq = window.matchMedia("(prefers-reduced-motion: reduce)");
  var hasIO = typeof IntersectionObserver !== "undefined";
  var tracked = new Set();
  var observer = null;

  document.documentElement.classList.add("scroll-reveal-ready");

  function setRevealed(el, revealed) {
    el.classList.toggle("is-revealed", revealed);
  }

  function assignOrder(el) {
    if (el.matches(ITEM_SELECTOR)) return;
    el.querySelectorAll(ITEM_SELECTOR).forEach(function (item, index) {
      if (!item.style.getPropertyValue("--reveal-order")) {
        item.style.setProperty("--reveal-order", String(index));
      }
    });
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      var el = entry.target;
      if (entry.isIntersecting) {
        setRevealed(el, true);
        if (el.getAttribute("data-scroll-reveal") === "once") untrack(el);
      } else {
        setRevealed(el, false);
      }
    });
  }

  function buildObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (!hasIO || reducedMq.matches) {
      tracked.forEach(function (el) {
        setRevealed(el, true);
      });
      return;
    }
    observer = new IntersectionObserver(onIntersect, {
      rootMargin: mobileMq.matches ? "0px 0px -18% 0px" : "0px 0px -22% 0px",
      threshold: 0.15
    });
    tracked.forEach(function (el) {
      observer.observe(el);
    });
  }

  function untrack(el) {
    tracked.delete(el);
    if (observer) observer.unobserve(el);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = [];
    if (scope.matches && scope.matches(SELECTOR)) els.push(scope);
    Array.prototype.push.apply(els, scope.querySelectorAll(SELECTOR));

    els.forEach(function (el) {
      if (tracked.has(el)) return;
      assignOrder(el);
      tracked.add(el);
      if (observer) {
        observer.observe(el);
      } else if (!hasIO || reducedMq.matches) {
        setRevealed(el, true);
      }
    });

    if (!observer && hasIO && !reducedMq.matches && tracked.size) buildObserver();
  }

  [mobileMq, reducedMq].forEach(function (mq) {
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", buildObserver);
    } else if (typeof mq.addListener === "function") {
      mq.addListener(buildObserver);
    }
  });

  document.addEventListener("shopify:section:unload", function (event) {
    tracked.forEach(function (el) {
      if (event.target.contains(el)) untrack(el);
    });
  });
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });

  window.ScrollReveal = { init: init, refresh: buildObserver };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
